var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('b-skeleton-table',{attrs:{"rows":_vm.rows || 7,"columns":_vm.columns || 5,"table-props":_vm.tableProps,"hide-header":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }